import Link from "next/link";
import Image from "next/image";
import { Twitter, Linkedin, Youtube } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#121212] text-gray-300 border-t border-gray-800">
      <div className="container mx-auto py-10 px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="mb-6 md:mb-0">
            <Link href="/" className="flex items-center mb-4">
              <Image
                src="/images/logo/logo_with_name.svg"
                alt="MeetMinutes Logo"
                width={120}
                height={40}
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-xs mb-4">Never miss a minute with MeetMinutes</p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  href="/pricing"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  href="/languages"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Languages
                </Link>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  href="/guide"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/terms"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Terms of use
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/refund-policy"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/google-api-services"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Google API Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Community</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/contact"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Contact us
                </Link>
              </li>
              <li>
                <Link
                  href="/careers"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  Careers
                </Link>
              </li>
            </ul>
            {/* Social Media Links - MOVED HERE */}
            <div className="flex mt-6 space-x-4">
              <a 
                href="https://x.com/MeetMinutes" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                <Twitter className="h-5 w-5" />
                <span className="sr-only">Twitter</span>
              </a>
              <a 
                href="https://www.linkedin.com/company/meetminutes" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                <Linkedin className="h-5 w-5" />
                <span className="sr-only">LinkedIn</span>
              </a>
              <a 
                href="https://www.youtube.com/@MeetMinutes" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                <Youtube className="h-5 w-5" />
                <span className="sr-only">YouTube</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 text-center text-sm">
          <p>&copy; 2025 MeetMinutes. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
